import {map} from 'rxjs/operators';
import {forkJoin, Observable} from 'rxjs';
import {of} from 'rxjs/internal/observable/of';

import {
    ApiError,
    ApiResponse,
    HttpStatusCodesEnum,
    TradingAccountStatusesEnum,
    TradingService,
    TradingAccountReportModel,
    TradingAccountStatusTriggerModel
} from '@spa/api';

import {Helper} from '../../../../shared/classes';
import {ReportTableDataRow} from '../../../../shared/components';

import {DisableAccountsFormErrorStatesEnum} from '../../enums';

export class DisableAccountsForm {
    private readonly tradingService: TradingService;

    public errors: string[];

    constructor(tradingService: TradingService) {
        this.errors = [];

        this.tradingService = tradingService;
    }

    private createTradingAccountBlockingRequest(
        id: number,
        reference: string
    ): Observable<ApiResponse<ApiError[] | number>> {
        const model = new TradingAccountStatusTriggerModel(id, TradingAccountStatusesEnum.Blocked);

        return this.tradingService.updateTradingAccountStatus(model)
            .pipe(
                map((response: ApiResponse<ApiError[] | null>) => {
                    if (response.status !== HttpStatusCodesEnum.Ok) {
                        const error = new ApiError(
                            DisableAccountsFormErrorStatesEnum.BlockTradingAccountFailed,
                            reference
                        );

                        return new ApiResponse<ApiError[]>(response.status, [error]);
                    }

                    return Helper.createSuccessResponse<number>(id);
                })
            );
    }

    initForm(): void {
    }

    validateForm(dataRows: ReportTableDataRow[], accountsForBlockingNotFoundMessage: string): boolean {
        this.errors = [];

        const selectedAccounts = dataRows.filter((row: ReportTableDataRow) => row.checked);

        if (selectedAccounts.length === 0) {
            this.errors.push(accountsForBlockingNotFoundMessage);

            return false;
        }

        return true;
    }

    createRequest(dataRows: ReportTableDataRow[]): Observable<ApiResponse<ApiError[] | number[]>> {
        const requests = dataRows.filter((row: ReportTableDataRow) => {
            return row.checked;
        }).map((row: ReportTableDataRow) => {
            const referenceDataItem = row.getItemByColId(TradingAccountReportModel.getAccountReferenceIdSelector());
            const reference = !referenceDataItem ? '' : referenceDataItem.value;

            return this.createTradingAccountBlockingRequest(row.rowId as number, reference);
        });

        if (requests.length !== 0) {
            return forkJoin(requests)
                .pipe(
                    map((responses: ApiResponse<ApiError[] | number>[]) => {
                        if (Helper.errorsHelper().checkForErrorResponses<number>(responses)) {
                            return Helper.errorsHelper().createReducedErrorResponse<number>(responses);
                        }

                        const data = responses.map((response: ApiResponse<ApiError[] | number>) => {
                            return response.data as number;
                        });

                        return Helper.createSuccessResponse<number[]>(data);
                    })
                );
        }

        const errorResponse = Helper.errorsHelper().createResponseForNoData(
            DisableAccountsFormErrorStatesEnum.DisableAccountsRequestsNotFound
        );

        return of(errorResponse);
    }
}
